import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";

function PickSection({ title, children, sheet, hideTitle }) {
  if (sheet) {
    return (
      <div className={aa.teamInvitePickSection}>
        {!hideTitle && title ? (
          <p className={aa.teamInvitePickTitle}>{title}</p>
        ) : null}
        <div className={aa.teamInvitePickList}>{children}</div>
      </div>
    );
  }
  return (
    <div className={s.branchCheckGrid} style={{ marginBottom: 16 }}>
      <p className={s.docSectionHint} style={{ gridColumn: "1 / -1", margin: 0 }}>
        {title}
      </p>
      {children}
    </div>
  );
}

function PickItem({ checked, onChange, children, sheet }) {
  if (sheet) {
    return (
      <label
        className={`${aa.teamInvitePickItem} ${
          checked ? aa.teamInvitePickItemOn : ""
        }`}
      >
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className={aa.teamInvitePickLabel}>{children}</span>
      </label>
    );
  }
  return (
    <label className={s.branchCheckItem}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span>{children}</span>
    </label>
  );
}

export default function TrainerAssignmentsFields({
  directions = [],
  groups = [],
  directionIds = [],
  groupIds = [],
  onToggleDirection,
  onToggleGroup,
  sheet = false,
  groupsOnly = false,
  optional = false,
  hideSectionTitle = false,
}) {
  const hintClass = sheet ? aa.hubHint : s.docSectionHint;
  const showDirections = !groupsOnly && directions.length > 0;

  if (!showDirections && !groups.length) {
    return sheet ? (
      <p className={hintClass}>
        {groupsOnly
          ? "Сначала добавьте группы в разделе «Группы»."
          : "Сначала добавьте направления и группы в разделе «Группы»."}
      </p>
    ) : null;
  }

  const groupTitle = optional ? "Группы (необязательно)" : "Группы";

  return (
    <>
      {showDirections ? (
        <PickSection title="Направления" sheet={sheet}>
          {directions.map((d) => (
            <PickItem
              key={d.id}
              sheet={sheet}
              checked={directionIds.includes(d.id)}
              onChange={() => onToggleDirection(d.id)}
            >
              {d.name}
            </PickItem>
          ))}
        </PickSection>
      ) : null}

      {groups.length > 0 ? (
        <PickSection
          title={groupTitle}
          sheet={sheet}
          hideTitle={hideSectionTitle}
        >
          {optional && !hideSectionTitle ? (
            <p
              className={hintClass}
              style={{ margin: sheet ? "0 0 8px" : "0 0 8px", gridColumn: "1 / -1" }}
            >
              Можно пропустить и назначить позже в профиле тренера.
            </p>
          ) : null}
          {groups.map((g) => (
            <PickItem
              key={g.id}
              sheet={sheet}
              checked={hasGroupId(groupIds, g.id)}
              onChange={() => onToggleGroup(g.id)}
            >
              {g.name}
              {g.sport_direction ? (
                <span className={aa.teamInvitePickMeta}>{g.sport_direction}</span>
              ) : null}
            </PickItem>
          ))}
        </PickSection>
      ) : null}
    </>
  );
}

export function toggleId(list, id) {
  const sid = String(id);
  const has = list.some((x) => String(x) === sid);
  return has ? list.filter((x) => String(x) !== sid) : [...list, id];
}

export function hasGroupId(groupIds, id) {
  const sid = String(id);
  return groupIds.some((x) => String(x) === sid);
}
